import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: true,
    isDebugMode: true,
    stage: 'dev',
    endpoint: 'https://api.dev-new.sal.siemens.cloud/v1',
    msalConfig: {
        auth: {
            clientId: 'ffd4cb3d-78a7-4f37-9d16-fc5ee9ba2faa',
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a',
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: true
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: false
        },
        system: {
            allowPlatformBroker: false
        }
    },
    apiConfig: [
        {
            scopes: ['https://api.dev.sal.siemens.cloud/SAL.Read'],
            uri: 'https://api.dev-new.sal.siemens.cloud'
        },
        {
            scopes: ['User.ReadBasic.All', 'User.Read'],
            uri: 'https://graph.microsoft.com/v1.0'
        }
    ],
    userManagementUrl:
        'https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Members/groupId/713db87a-babd-4fac-8cce-258b4eb3dc62'
};
